module.exports = __webpack_public_path__ + "img/ner_tagger_how_to.6f1334b4.svg";